"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldDisplayErrorBannerWhenFailed = shouldDisplayErrorBannerWhenFailed;
exports.refetchAuthedUsersAfterAdAccountDeletion = refetchAuthedUsersAfterAdAccountDeletion;
exports.refetchAccountsAfterDeletionFails = refetchAccountsAfterDeletionFails;
exports.refetchSelectedPagesAfterPageSelection = refetchSelectedPagesAfterPageSelection;
exports.refetchSelectedPagesAfterPageDeletion = refetchSelectedPagesAfterPageDeletion;
exports.refetchPixelsAfterInstallation = refetchPixelsAfterInstallation;
exports.closePixelModalAfterInstallation = closePixelModalAfterInstallation;

var _of = require("rxjs/observable/of");

var _filter = require("rxjs/operators/filter");

var _mergeMap = require("rxjs/operators/mergeMap");

var _map = require("rxjs/operators/map");

var _delay = require("rxjs/operators/delay");

var _actions = require("settings-ui-sdk/AdsAccounts/actions");

var _actions2 = require("settings-ui-sdk/AdsPixel/actions");

var _AdsActions = require("../actions/AdsActions");

var _NotificationActions = require("ReduxMessenger/actions/NotificationActions");

var _react = _interopRequireDefault(require("react"));

var _ErrorNotification = _interopRequireDefault(require("../components/ErrorNotification"));

function shouldDisplayErrorBannerWhenFailed($action) {
  return $action.pipe((0, _filter.filter)(function (_ref) {
    var type = _ref.type;
    return type.match(/^ads\/.*(FAILURE$)/);
  }), (0, _map.map)(function (action) {
    return (0, _NotificationActions.postNotification)({
      id: 'ads-failure',
      message: _react.default.createElement(_ErrorNotification.default, {
        action: action
      }),
      type: 'danger'
    });
  }));
}

function refetchAuthedUsersAfterAdAccountDeletion($action) {
  return $action.ofType(_actions.DeleteAdAccountActionTypes.SUCCESS, _actions.DeleteUserAuthActionTypes.SUCCESS).pipe((0, _map.map)(_actions.fetchConnectedUsers), (0, _delay.delay)(1000) // delay due to OAuthor fetch
  );
}

function refetchAccountsAfterDeletionFails($action) {
  return $action.ofType(_actions.DeleteAdAccountActionTypes.FAILURE).pipe((0, _mergeMap.mergeMap)(function () {
    return (0, _of.of)((0, _actions.fetchAdAccounts)(), (0, _actions.fetchConnectedUsers)());
  }));
}

function refetchSelectedPagesAfterPageSelection($action) {
  return $action.ofType(_actions.SelectLeadSyncingEntitiesActionTypes.SUCCESS).pipe((0, _map.map)(_actions.fetchSelectedLeadSyncingEntities));
}

function refetchSelectedPagesAfterPageDeletion($action) {
  return $action.ofType(_actions.UnsubscribeLeadSyncingEntityActionTypes.SUCCESS).pipe((0, _map.map)(_actions.fetchSelectedLeadSyncingEntities));
}

function refetchPixelsAfterInstallation($action) {
  return $action.ofType(_actions2.CreateAndInstallPixelsActionTypes.SUCCESS).pipe((0, _map.map)(_actions2.fetchPixels));
}

function closePixelModalAfterInstallation($action) {
  return $action.ofType(_actions2.CreateAndInstallPixelsActionTypes.SUCCESS).pipe((0, _map.map)(_AdsActions.closeModal));
}